module.exports = __webpack_public_path__ + "static/media/botmaker.3fa6680f.png";